<template>
  <div class="changelog-timeline">
    <a-timeline>
      <a-timeline-item v-for="changelog in changelogData" :key="changelog.id">
        <div class="timeline-content">
          <span slot="title" class="changelog-header">
            <span class="version">{{ changelog.version }}</span>
            <span class="title">{{ changelog.title }}</span>
            <span class="release-time">{{ changelog.release_time }}</span>
          </span>
          <div v-if="changelog.images" class="changelog-images">
            <image-carousel :images="changelog.images" />
          </div>
          <vditor-preview :content="changelog.content" />
        </div>
      </a-timeline-item>
    </a-timeline>
  </div>
</template>

<script>
import VditorPreview from '@/components/VditorEditor/preview';
import ImageCarousel from '@/components/ImageCarousel';
import { changelogList } from '@/api/system/about';

export default {
  components: { VditorPreview, ImageCarousel },
  data() {
    return {
      loading: false,
      changelogData: []
    };
  },
  created() {
    this.getChangelogList();
  },
  methods: {
    // 获取更新日志列表
    getChangelogList() {
      this.loading = true;
      changelogList({ status: 2 })
        .then(res => {
          this.changelogData = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-carousel .slick-slide {
  text-align: center;
  height: 400px;
  overflow: hidden;
}
.changelog-timeline {
  width: 1000px;
  margin: 0px auto;
  .timeline-content {
    width: 960px;
  }
  .changelog-content {
    margin-top: 10px;
  }

  .changelog-header {
    display: block;
    line-height: 48px;
    margin-bottom: 2px;
    .version {
      font-size: 26px;
      font-weight: bold;
      margin-right: 10px;
      color: #108ee9;
    }
    .title {
      font-size: 18px;
      margin-right: 10px;
    }
    .release-time {
      font-size: 13px;
      color: #9b9b9b;
    }
  }
}
</style>
